var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3H16.5V1.5H15V3H9V1.5H7.5V3H4.5C3.6 3 3 3.6 3 4.5V19.5C3 20.4 3.6 21 4.5 21H19.5C20.4 21 21 20.4 21 19.5V4.5C21 3.6 20.4 3 19.5 3ZM19.5 19.5H4.5V9H19.5V19.5ZM19.5 7.5H4.5V4.5H7.5V6H9V4.5H15V6H16.5V4.5H19.5V7.5Z",
    fill: "#000103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesi);
export default __webpack_public_path__ + "static/media/mesi.52637fc85894c8311b08be21e2165ce8.svg";
export { ForwardRef as ReactComponent };